<template>
  <b-modal class="cx_listEditor3" :class="{cx_modal_maximized: maximized}" :style="modalStyle" v-model="show" :title="$translate(title)" @ok="onOk" :no-close-on-backdrop="true" centered :key="bindIndex" ref="modal" :html="html">   
      <button  slot="modal-header" type="button" aria-label="Close" class="maximize" v-if="$api.spMode == false" @click="onChangeDisplayMode"><i class="material-icons small valign">{{maximized ? 'filter_none' : 'check_box_outline_blank'}}</i></button>
      <div class="cx_list_dialog_outer">
      <!-- ヘッダスロット-->
      <div class="cx_list_dialog_header">
        <slot name="header" :editor="_self"></slot>
      </div>
      <!-- 行追加ボタンの配置 -->
      <div class="add_div">
        <slot name="buttons"></slot>
        <Button class="button" v-if="showAdd" @click="onAddRow" caption="追加" icon="add_circle" />
        <Button class="button" v-if="showGearButton && captions && captions.length > 0" @click="onShowSelector" caption="表示設定" icon="settings" />
      </div>
      <div class="cx_list_wrap_header" v-if="captions && captions.length > 0" :class="{ 'cx_list_no_wrap': !wrapDisplay }" :style="detailHeaderStyle" ref="listHead">
        <div class="remove_header" v-if="showRemove"></div>
        <div class="leading_header" v-if="showLeading"></div>
        <div class="cx_list_wrap_fields">
          <div v-for="(column, index) in columns" :key="column.slot" :data-header-id="index" class="cx_list_wrap_caption label-item" :class="{ 'cx_list_header_drop_target': headerDropTargetId === index, 'cx_list_header_drop_after': headerDropAfter, 'cx_list_header_drop_last': headerDropTargetId === index && headerDropAfter && index === columns.length - 1 }" :style="getColumnStyle(column)" @dragover.prevent="headerDragOver(index, $event)" @drop="headerDrop">
            <span>{{ $translate(column.caption) }}</span>
            <i class="material-symbols-outlined cx_list_header_grip" draggable="true" title="ドラッグして表示順を変更" @dragstart="headerDragStart(index, $event)" @dragend="headerDragEnd" @touchstart.prevent="headerTouchStart(index)" @touchmove.prevent="headerTouchMove($event)" @touchend.prevent="headerTouchEnd">drag_indicator</i>
          </div>
        </div>
      </div>
      <div class="cx_list_container cx_list_wrap_container" v-if="captions && captions.length > 0" :class="{ 'cx_list_no_wrap': !wrapDisplay }" :style="detailBodyStyle" ref="listView" @scroll="onScroll">
        <div class="cx_list_wrap_row" v-for="(item, row) in items" :key="item.listDialog_rowKey ? item.listDialog_rowKey : row" :class="{ rowHighlight: isActiveRow(row) }">
          <div class="remove_cell" v-if="showRemove">
            <b-link @click="onRemoveRow(row)" class="button_remove"><i class="material-icons small valign">remove_circle</i></b-link>
          </div>
          <div class="leading_cell" v-if="showLeading">
            <slot name="leading" :item="item" :editor="_self" :row="row"></slot>
          </div>
          <div class="cx_list_wrap_fields">
            <div :id="row + '_' + column.slot" v-for="column in columns" :key="column.slot" class="control_cell cx_list_wrap_cell" :style="getColumnStyle(column)" @focusin="setActive(row,column.slot)" @keydown.up.prevent="moveFocus('up')" @keydown.down.prevent="moveFocus('down')" @keydown.left.prevent="moveFocus('left')" @keydown.right.prevent="moveFocus('right')">
              <slot :name="'col' + column.slot" :item="item" :editor="_self" :row="row"></slot>
            </div>
          </div>
        </div>
      </div>
      <!-- フッタスロット-->
      <div class="cx_list_dialog_footer">
        <slot name="footer" :editor="_self"></slot> 
      </div>
    </div>  
    <b-modal v-model="selectorVisible" title="表示設定" @ok="onColumnSelectorOk" :no-close-on-backdrop="true" centered modal-class="cx_list_column_selector_modal">
      <div class="selector">
        <div class="selector_size">
         <div class="selector_size_item">
            <label>画面横幅</label>
            <NumericBox :value="selectorWidth" @update:value="onSelectorWidthChanged" :min="minimumDialogWidth" suffix="px" />
          </div>
          <div class="selector_size_item">
            <label>画面高さ</label>
            <NumericBox :value="selectorHeight" @update:value="onSelectorHeightChanged" :min="minimumDialogHeight" suffix="px" />
          </div>

          <div class="selector_size_item">
            <label>セル基準幅</label>
            <NumericBox :value.sync="selectorBaseWidth" :min="minimumColumnWidth" suffix="px" />
          </div>
           <div class="selector_size_item">
            <label>折り返し</label>
            <toggle-button :key="selectorWrapDisplay" v-model="selectorWrapDisplay" :labels="{ checked: 'オン', unchecked: 'オフ' }" :width="65" :font-size="11" color="#7a2e2e" />
          </div>
          <Button class="button" @click="onDialogSizeReset" caption="リセット" icon="refresh" />
        </div>
        <div class="selector_body">
          <table class="dialog">
            <colgroup><col width="200" /></colgroup>
            <tbody>
              <tr v-for="(column, index) in columnVisibilities" :key="column.slot" :data-item-id="index" @dragover="selectorDragOver($event)" @drop="selectorDrop(index)">
                <td class="dialog_cell"><b-form-checkbox v-model="column.visible" :disabled="column.required" size="sm">{{ $translate(column.caption) }}</b-form-checkbox></td>
                <td class="dialog_width"><b-form-select v-model.number="column.span" :options="columnSpanOptions" size="sm" /></td>
                <td class="dialog_grip"><i class="material-symbols-outlined small valign" draggable="true" @dragstart="selectorDragStart(index)" @touchstart.stop="selectorDragStart(index)" @touchmove.prevent.stop="selectorDragMove($event)" @touchend.stop="selectorTouchEnd($event)">drag_indicator</i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
      <!-- フッタにボタンスロットを追加-->
      <div v-if="!buttonNames" slot="modal-footer" class="cx_modal_footer_button_container">
        <slot name="footer_buttons"></slot>
      </div>
      <button v-if="!buttonNames" slot="modal-footer" type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeDialog" >キャンセル</button>        
      <button v-if="!buttonNames" slot="modal-footer" type="button" class="btn btn-primary" data-dismiss="modal" @click="onOk" >OK</button>          

    <!-- ワークフローアクション毎の複数ボタン対応 -->
    <button v-if="buttonNames" slot="modal-footer" type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeDialog" >キャンセル</button>
    <button v-for="(item, key) in buttonNames" :key="key" slot="modal-footer" type="button" :class="(buttonNames.length>1 && key==0) ? 'btn btn-info' : 'btn btn-primary'" @click="onCustomOK($event,key)" >{{item}}</button>
    <div slot="modal-footer" class="dialog_resize_handle" v-if="$api.spMode == false && maximized == false" aria-label="ダイアログのサイズを変更" @pointerdown.prevent="onResizeStart"></div>
    <!-- <button v-if="buttonNames" slot="modal-footer" type="button" class="btn btn-primary" @click="onWorkflowAction(null)" >OK</button> -->
  </b-modal>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';

interface ListDialogColumn {
  caption: string;
  span: number;
  position: number;
  slot: number;
  required: boolean;
}

interface ListDialogColumnSetting extends ListDialogColumn {
  visible: boolean;
}

interface ListDialogColumnLayout {
  slot: number;
  span?: number;
  /** 旧設定との互換用。span がない場合の初期値計算に使用する。 */
  width?: number;
  position: number;
  visible: boolean;
}

interface ListDialogLayoutSetting {
  columns: Array<ListDialogColumnLayout>;
  width: number;
  height: number;
  wrapDisplay?: boolean;
  baseWidth?: number;
}

const MIN_DIALOG_WIDTH = 320;
const MIN_DIALOG_HEIGHT = 120;
const MIN_COLUMN_WIDTH = 40;
const DEFAULT_BASE_WIDTH = 125;
const MAX_COLUMN_SPAN = 4;
const FIELD_GAP = 2;

@Component
export default class ListDialog extends Vue implements Components.IEditor {
  @Prop({ default: '' }) public title: string; //タイトル
  @Prop({ default: '' }) public modelName: string;
  // @Prop({ default: ()=> new Array()}) public items: Array<any>;
  @Prop({ default: null }) public captions: Array<string>;
  @Prop({ default: null }) public widths: Array<number>;
  @Prop({ default: null }) public requireds: Array<boolean>;
  @Prop({ default: false }) public primitive: boolean;
  @Prop({ default: null }) public defaultValue: any;
  /**非同期実行ハンドラを指定すると完了まで待機します。 */
  @Prop({default:null}) public exec: (items:any[])=>Promise<boolean>;
  @Prop({default:true}) public showAdd:boolean;
  @Prop({default:true}) public showRemove:boolean;
  @Prop({default:false}) public showLeading:boolean;
  @Prop({ default: null }) public onCreate: (item: any) => Promise<any>;  
  @Prop({default:null}) public width:number;
  @Prop({default:null}) public height:number;
  /**カラム表示設定を保存する LocalStorage のキー */
  @Prop({ default: '' }) public storageKey: string;
  @Prop({ default: true }) public showGearButton: boolean;
  @Prop({ default: null }) public buttonNames: Array<string>;
  @Prop({default:null}) public execWithIndex: (items:any[], index:number)=>Promise<boolean>;  
  //プリミティブの場合は匿名オブジェクトのvalueプロパティをバインドします。
  @Prop({default:null}) public html: string;
  @Prop({default: false}) public isRemainAfterExec: boolean;

  public activeRow:number = null;
  public activeCol:number = null;
  /**表示順・表示幅・元のスロット番号を保持するカラム定義 */
  public columns: Array<ListDialogColumn> = new Array();
  public selectorVisible: boolean = false;
  public columnVisibilities: Array<ListDialogColumnSetting> = new Array();
  private selectorTargetId: number = -1;
  private headerTargetId: number = -1;
  private headerDropTargetId: number = -1;
  private headerDropAfter: boolean = false;
  /** 呼び出し側の既定値を上書きする、保存済みのダイアログ外枠サイズ */
  public dialogWidth: number = null;
  public dialogHeight: number = null;
  /** 明細を列幅に応じて折り返すかどうか */
  public wrapDisplay: boolean = true;
  public selectorWidth: number = null;
  public selectorHeight: number = null;
  /** 設定画面を開いた時点のダイアログサイズ。未変更判定に使用します。 */
  private selectorInitialWidth: number = null;
  private selectorInitialHeight: number = null;
  /** 折り返し時のグリッド基準幅 */
  public baseWidth: number = DEFAULT_BASE_WIDTH;
  /** 設定画面内で編集する基準幅の一時値 */
  public selectorBaseWidth: number = DEFAULT_BASE_WIDTH;
  /** 設定画面内で編集する折り返し表示の一時値 */
  public selectorWrapDisplay: boolean = true;
  public readonly minimumDialogWidth: number = MIN_DIALOG_WIDTH;
  public readonly minimumDialogHeight: number = MIN_DIALOG_HEIGHT;
  public readonly minimumColumnWidth: number = MIN_COLUMN_WIDTH;
  public readonly columnSpanOptions = [1, 2, 3, 4].map(value => ({ value, text: value + ' 倍' }));
  private resetDialogSize: boolean = false;
  private resizeStartX: number = 0;
  private resizeStartY: number = 0;
  private resizeStartWidth: number = 0;
  private resizeStartHeight: number = 0;
    

    public moveFocus(direction:string){
      let currentRow = this.activeRow;
      let currentCol = this.columns.findIndex(column => column.slot === this.activeCol);
      if (currentRow == null || currentCol < 0 || this.columns.length === 0) return;

      // 非入力列を飛ばしながら、横移動では行端を越えた場合に次/前行へ折り返します。
      const maxAttempts = this.items.length * this.columns.length;
      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        switch (direction) {
          case 'left':
            currentCol--;
            if (currentCol < 0) {
              currentRow--;
              currentCol = this.columns.length - 1;
            }
            break;
          case 'right':
            currentCol++;
            if (currentCol >= this.columns.length) {
              currentRow++;
              currentCol = 0;
            }
            break;
          case 'up':
            currentRow--;
            break;
          case 'down':
            currentRow++;
            break;
          default:
            return;
        }

        if (currentRow < 0 || currentRow >= this.items.length) return;

        const column = this.columns[currentCol];
        const element = document.getElementById(currentRow + '_' + column.slot);
        const controlElement: HTMLElement = element?.querySelector('input, select, textarea, button');
        if (controlElement) {
          this.activeCol = column.slot;
          this.activeRow = currentRow;
          controlElement.focus();
          return;
        }
      }
    }

    public setActive(row:number,col:number){
      this.activeRow = row;
      this.activeCol = col;
    }

    public isActiveRow(num:number) {
      return num == this.activeRow;
    }
    public isActiveCell(row:number,col:number) {
      return col == this.activeCol && row == this.activeRow;
    }

  public items: Array<any> = new Array();
  public show: boolean = false; //リスト
  public created() {
    this.loadColumns();
  }
  @Watch('captions', { immediate: true })
  public onCaptionsChanged() {
    this.loadColumns();
  }
  @Watch('widths', { immediate: true })
  public onWidthsChanged() {
    this.loadColumns();
  }
  public showDialog() {
    this.loadColumns();
    this.activeRow = null;
    this.activeCol=null;
    this.listDialog_rowKey = 0;
    if(this.items)this.items.forEach(item => this.setRowKey(item));
    this.maximized = false;
    this.show = true;
  }
  public closeDialog() {
    this.show = false;
    this.$emit('closeDialog');
  }

  /** 通常表示では既定の明細領域幅、リサイズ後はダイアログ幅いっぱいに表示します。 */
  public get detailHeaderStyle(): string {
    if (this.$api.spMode || this.maximized) return  'max-width:unset;';    
    else if (this.dialogWidth != null) return 'width:100%;max-width:unset;';
    else return this.width ? 'width:' + this.width +'px; max-width:unset;':'';
  }
  /** 通常表示では既定の明細領域サイズ、リサイズ後は残り領域を使用します。 */
  public get detailBodyStyle(): string {
    if (this.$api.spMode) return (this.effectiveHeight ? 'height:' + this.effectiveHeight + 'px;overflow-y:auto;flex:1 1 auto;':'') + 'max-width:unset;';
    else if (this.maximized) return 'max-width:unset;flex:1';
    else if (this.dialogHeight != null || this.dialogWidth != null) return 'width:100%;height:auto;max-height:unset;overflow-y:auto;flex:1;min-height:0;';
    // 初期高さを指定している場合も、viewportが不足するときは明細領域を縮小して
    // 内部スクロールへ切り替える。flex:none のままだとフッターの下へはみ出す。
    else return (this.height ? 'height:' + this.height + 'px;max-height:unset;overflow-y:auto;flex:0 1 auto;min-height:0;':'') + (this.width ? 'width:' + this.width +'px; max-width:unset;':'' );
  }    
  /** ユーザー操作で変更した場合のみ、モーダル全体へ幅・高さを適用します。 */
  public get modalStyle(): any {
    return {
      '--cx-list-dialog-width': this.dialogWidth != null ? this.dialogWidth + 'px' : null,
      '--cx-list-dialog-height': this.dialogHeight != null ? this.dialogHeight + 'px' : null,
    };
  }
  /** 保存値がなければ、呼び出し側から渡された既定値を使用します。 */
  public get effectiveWidth(): number {
    return this.dialogWidth != null ? this.dialogWidth : this.width;
  }
  public get effectiveHeight(): number {
    return this.dialogHeight != null ? this.dialogHeight : this.height;
  }
  public onScroll() {
    const listHead = this.$refs.listHead as HTMLElement;
    const listView = this.$refs.listView as HTMLElement;
    if (listHead && listView) listHead.scrollLeft = listView.scrollLeft;
  }
 @Watch('show')
 public onShowChanged(){
   if(this.show) {
     this.bindIndex+=1;
     this.$nextTick(() => this.setMainDialogClass());
   }
 }
  /** 入れ子の設定モーダルへサイズ設定が伝播しないよう、親ダイアログだけを識別します。 */
  public setMainDialogClass() {
    const mainDialog = this.getMainDialogElement();
    if (mainDialog) mainDialog.classList.add('cx_list_main_dialog');
  }
  public bindIndex = 0;
  private getDefaultColumns(): Array<ListDialogColumn> {
    if (!this.captions || !this.widths) return new Array();
    return this.captions.map((caption, slot) => ({
      caption: caption,
      span: this.getColumnSpan(this.widths[slot], DEFAULT_BASE_WIDTH),
      position: slot,
      slot: slot,
      required: this.requireds != null && this.requireds[slot] === true,
    }));
  }
  private getDefaultColumnSettings(): Array<ListDialogColumnSetting> {
    return this.getDefaultColumns().map(column => ({ ...column, visible: true }));
  }
  private getColumnSelectorItems(): Array<ListDialogColumnSetting> {
    const currentColumns = new Map(this.columns.map(column => [column.slot, column]));
    return this.getDefaultColumns().map(defaultColumn => {
      const current = currentColumns.get(defaultColumn.slot);
      return {
        ...(current || defaultColumn),
        required: defaultColumn.required,
        visible: current != null || defaultColumn.required,
      };
    }).sort((a, b) => {
      if (a.visible !== b.visible) return a.visible ? -1 : 1;
      return a.position - b.position || a.slot - b.slot;
    });
  }
  /**既定の captions/widths と保存済み設定から表示カラムを作成します。 */
  public loadColumns() {
    const defaults = this.getDefaultColumns();
    const previousColumns = this.columns;
    this.columns = new Array();
    if (defaults.length === 0) return;

    let settings: Array<ListDialogColumnLayout> = new Array();
    this.dialogWidth = null;
    this.dialogHeight = null;
    this.wrapDisplay = true;
    this.baseWidth = DEFAULT_BASE_WIDTH;
    if (this.storageKey) {
      try {
        const value = localStorage.getItem(this.storageKey);
        if (value) {
          const saved = JSON.parse(value);
          // 旧形式（カラム配列）との互換性を維持する
          settings = Array.isArray(saved) ? saved : (saved.columns || new Array());
          if (!Array.isArray(saved)) {
            this.dialogWidth = saved.width > 0 ? saved.width : null;
            this.dialogHeight = saved.height > 0 ? saved.height : null;
            this.wrapDisplay = typeof saved.wrapDisplay === 'boolean' ? saved.wrapDisplay : true;
            this.baseWidth = saved.baseWidth >= MIN_COLUMN_WIDTH ? saved.baseWidth : DEFAULT_BASE_WIDTH;
          }
        }
      } catch (e) {
        settings = new Array();
      }
    } else if (previousColumns.length > 0) {
      // storageKey未指定の場合も、ダイアログ再表示時に現在の表示設定を維持する
      settings = defaults.map(defaultColumn => {
        const current = previousColumns.find(column => column.slot === defaultColumn.slot);
        return {
          slot: defaultColumn.slot,
          span: current != null ? current.span : defaultColumn.span,
          position: current != null ? current.position : defaultColumn.position,
          visible: current != null,
        };
      });
    }

    defaults.forEach(defaultColumn => {
      const current = settings.find(setting => setting.slot === defaultColumn.slot);
      if (current == null || current.visible || defaultColumn.required) {
        this.columns.push({
          caption: defaultColumn.caption,
          span: current != null
            ? this.getColumnSpan(current.span != null ? current.span * this.baseWidth : current.width, this.baseWidth)
            : this.getColumnSpan(this.widths[defaultColumn.slot], this.baseWidth),
          position: current != null ? current.position : defaultColumn.position,
          slot: defaultColumn.slot,
          required: defaultColumn.required,
        });
      }
    });
    this.columns.sort((a, b) => a.position - b.position || a.slot - b.slot);
  }
  /**現在の列レイアウトを既定幅との差分ではなく有効な状態で保存します。 */
  public saveColumns() {
    if (!this.storageKey || !this.captions) return;
    const settings: Array<ListDialogColumnLayout> = this.getDefaultColumns().map(defaultColumn => {
      const column = this.columns.find(item => item.slot === defaultColumn.slot);
      return column == null
        ? { slot: defaultColumn.slot, span: 1, position: defaultColumn.position, visible: false }
        : { slot: defaultColumn.slot, span: column.span, position: this.columns.indexOf(column), visible: true };
    });
    const layout: ListDialogLayoutSetting = {
      columns: settings,
      width: this.dialogWidth,
      height: this.dialogHeight,
      wrapDisplay: this.wrapDisplay,
      baseWidth: this.baseWidth,
    };
    localStorage.setItem(this.storageKey, JSON.stringify(layout));
  }
  public onShowSelector() {
    this.columnVisibilities = this.getColumnSelectorItems();
    // 設定画面には、現在表示されているモーダル全体の実サイズを表示する。
    // width/height の指定値を元に再計算すると、viewportによる縮小後の実サイズと
    // 一致しないため、必ず実測値を使用する。
    this.selectorWidth = this.getSelectorDialogSize('width');
    this.selectorHeight = this.getSelectorDialogSize('height');
    this.selectorInitialWidth = this.selectorWidth;
    this.selectorInitialHeight = this.selectorHeight;
    this.selectorWrapDisplay = this.wrapDisplay;
    this.selectorBaseWidth = this.baseWidth;
    this.resetDialogSize = false;
    this.selectorVisible = true;
  }
  public onColumnSelectorOk() {
    const newColumns: Array<ListDialogColumn> = new Array();
    this.columnVisibilities.filter(column => column.visible || column.required).forEach((column, position) => {
      const current = this.columns.find(item => item.slot === column.slot);
      newColumns.push({
        caption: column.caption,
        span: this.getColumnSpan(column.span, 1),
        position: position,
        slot: column.slot,
        required: column.required,
      });
    });
    this.columns = newColumns;
    this.dialogWidth = this.resetDialogSize
      ? null
      : this.getSelectedDialogSize(this.selectorWidth, this.selectorInitialWidth, this.dialogWidth, MIN_DIALOG_WIDTH);
    this.dialogHeight = this.resetDialogSize
      ? null
      : this.getSelectedDialogSize(this.selectorHeight, this.selectorInitialHeight, this.dialogHeight, MIN_DIALOG_HEIGHT);
    this.wrapDisplay = this.selectorWrapDisplay;
    this.baseWidth = Math.max(MIN_COLUMN_WIDTH, this.selectorBaseWidth);
    this.saveColumns();
  }
  /** 呼び出し側で指定した既定のサイズ・カラム表示へ戻します。 */
  public onDialogSizeReset() {
    this.selectorWidth = this.getDefaultDialogSize('width');
    this.selectorHeight = this.getDefaultDialogSize('height');
    this.columnVisibilities = this.getDefaultColumnSettings();
    this.selectorWrapDisplay = true;
    this.selectorBaseWidth = DEFAULT_BASE_WIDTH;
    this.resetDialogSize = true;
  }
  /** リサイズ設定画面では、明細領域ではなくmodal-contentの実寸を表示します。 */
  private getCurrentDialogSize(dimension: 'width' | 'height'): number {
    const content = this.getMainModalContentElement();
    if (content) return Math.round(content.getBoundingClientRect()[dimension]);
    return dimension === 'width' ? this.effectiveWidth : this.effectiveHeight;
  }
  private getSelectorDialogSize(dimension: 'width' | 'height'): number {
    // 設定画面の「画面サイズ」は一覧領域ではなく、ダイアログ外枠のサイズを表示する。
    // 保存済みサイズがある場合は、その値が現在のダイアログサイズなので優先する。
    const savedSize = dimension === 'width' ? this.dialogWidth : this.dialogHeight;
    return savedSize != null ? savedSize : this.getCurrentDialogSize(dimension);
  }
  /** 既定の明細領域サイズに、ヘッダー・フッター・余白の寸法を加算します。 */
  private getDefaultDialogSize(dimension: 'width' | 'height'): number {
    const content = this.getMainModalContentElement();
    const listView = this.$refs.listView as HTMLElement;
    const defaultDetailSize = dimension === 'width' ? this.width : this.height;
    if (content && listView && defaultDetailSize != null) {
      const dialogSize = content.getBoundingClientRect()[dimension];
      const detailSize = listView.getBoundingClientRect()[dimension];
      return Math.round(defaultDetailSize + Math.max(0, dialogSize - detailSize));
    }
    return this.getCurrentDialogSize(dimension);
  }
  private getMainDialogElement(): HTMLElement {
    const modal = this.$refs.modal as any;
    let dialog = modal && modal.$el ? modal.$el.querySelector('.modal-dialog') as HTMLElement : null;
    if (!dialog) dialog = document.querySelector('.cx_listEditor3 > .modal-dialog') as HTMLElement;
    return dialog;
  }
  private getMainModalContentElement(): HTMLElement {
    const dialog = this.getMainDialogElement();
    return dialog ? dialog.querySelector('.modal-content') as HTMLElement : null;
  }
  public onSelectorWidthChanged(value: number) {
    this.selectorWidth = value;
    this.resetDialogSize = false;
  }
  public onSelectorHeightChanged(value: number) {
    this.selectorHeight = value;
    this.resetDialogSize = false;
  }
  private getDialogSize(value: number, minimum: number): number {
    if (value == null) return null;
    return Math.max(minimum, value);
  }
  /** サイズを変更していない場合は、未設定(null)を維持して自動計算を継続します。 */
  private getSelectedDialogSize(value: number, initialValue: number, currentValue: number, minimum: number): number {
    if (currentValue == null && value === initialValue) return null;
    return this.getDialogSize(value, minimum);
  }
  /** 元のピクセル幅または保存済みの倍率を、1～4の基準幅倍率に正規化します。 */
  private getColumnSpan(value: number, baseWidth: number): number {
    if (value == null || value <= 0) return 1;
    const span = baseWidth === 1 ? value : Math.round(value / baseWidth);
    return Math.max(1, Math.min(MAX_COLUMN_SPAN, span));
  }
  /** 倍率分の基準幅に、セル間に含まれる gap を加算してグリッドを揃えます。 */
  public getColumnStyle(column: ListDialogColumn): any {
    const span = this.getColumnSpan(column.span, 1);
    const width = this.baseWidth * span + (span - 1) * FIELD_GAP;
    return { width: width + 'px' };
  }
  public onResizeStart(event: any) {
    const content = this.getMainModalContentElement();
    const listView = this.$refs.listView as HTMLElement;
    this.resizeStartX = event.clientX;
    this.resizeStartY = event.clientY;
    this.resizeStartWidth = content ? content.getBoundingClientRect().width : (listView ? listView.clientWidth : MIN_DIALOG_WIDTH);
    this.resizeStartHeight = content ? content.getBoundingClientRect().height : (listView ? listView.clientHeight : MIN_DIALOG_HEIGHT);
    window.addEventListener('pointermove', this.onResizeMove);
    window.addEventListener('pointerup', this.onResizeEnd);
    window.addEventListener('pointercancel', this.onResizeEnd);
  }
  public onResizeMove(event: any) {
    const maximumWidth = Math.max(MIN_DIALOG_WIDTH, window.innerWidth - 20);
    const maximumHeight = Math.max(MIN_DIALOG_HEIGHT, window.innerHeight - 20);
    this.dialogWidth = Math.min(maximumWidth, Math.max(MIN_DIALOG_WIDTH, this.resizeStartWidth + event.clientX - this.resizeStartX));
    this.dialogHeight = Math.min(maximumHeight, Math.max(MIN_DIALOG_HEIGHT, this.resizeStartHeight + event.clientY - this.resizeStartY));
  }
  public onResizeEnd() {
    window.removeEventListener('pointermove', this.onResizeMove);
    window.removeEventListener('pointerup', this.onResizeEnd);
    window.removeEventListener('pointercancel', this.onResizeEnd);
    this.saveColumns();
  }
  public destroyed() {
    this.onResizeEnd();
  }
  public selectorDragStart(index: number) {
    this.selectorTargetId = index;
  }
  public selectorDragOver(event: any) {
    if (event.preventDefault) event.preventDefault();
  }
  public selectorDrop(index: number) {
    const target = this.columnVisibilities[this.selectorTargetId];
    if (!target || this.selectorTargetId === index) return;
    this.columnVisibilities.splice(this.selectorTargetId, 1);
    this.columnVisibilities.splice(index, 0, target);
  }
  public selectorDragMove(event: any) {
    const touch = event.changedTouches[0];
    const element = event.target as HTMLElement;
    element.style.position = 'fixed';
    element.style.top = touch.clientY + window.scrollY - element.offsetHeight / 2 + 'px';
    element.style.left = touch.clientX + window.scrollX - element.offsetWidth / 2 + 'px';
    if (event.preventDefault) event.preventDefault();
  }
  public selectorTouchEnd(event: any) {
    const element = event.target as HTMLElement;
    element.style.position = '';
    element.style.top = '';
    element.style.left = '';
    const touch = event.changedTouches[0];
    const dropElement = document.elementFromPoint(touch.clientX, touch.clientY) as HTMLElement;
    const dropRow = dropElement && dropElement.closest('[data-item-id]') as HTMLElement;
    const index = Number(dropRow && dropRow.getAttribute('data-item-id'));
    if (!Number.isNaN(index)) this.selectorDrop(index);
  }
  /** ヘッダのグリップ操作で表示カラムの順序を変更します。 */
  public headerDragStart(index: number, event: DragEvent) {
    this.headerTargetId = index;
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', String(index));
      const label = (event.currentTarget as HTMLElement).closest('.label-item') as HTMLElement;
      if (label) event.dataTransfer.setDragImage(label, Math.max(0, label.clientWidth - 6), 12);
    }
  }
  /** ドラッグ中のカラムが挿入される位置を表示します。 */
  public headerDragOver(index: number, event: DragEvent) {
    if (this.headerTargetId === index) return;
    const label = event.currentTarget as HTMLElement;
    const bounds = label.getBoundingClientRect();
    this.headerDropTargetId = index;
    this.headerDropAfter = event.clientX >= bounds.left + bounds.width / 2;
  }
  public headerDragEnd() {
    this.headerTargetId = -1;
    this.headerDropTargetId = -1;
    this.headerDropAfter = false;
  }
  /** SPモードではグリップのタッチ操作でヘッダ表示順を変更します。 */
  public headerTouchStart(index: number) {
    this.headerTargetId = index;
    this.headerDropTargetId = -1;
    this.headerDropAfter = false;
  }
  public headerTouchMove(event: TouchEvent) {
    const touch = event.changedTouches[0];
    const element = document.elementFromPoint(touch.clientX, touch.clientY) as HTMLElement;
    const label = element && element.closest('[data-header-id]') as HTMLElement;
    if (!label) return;
    const index = Number(label.getAttribute('data-header-id'));
    if (!Number.isNaN(index)) this.headerDragOver(index, {
      currentTarget: label,
      clientX: touch.clientX,
    } as any as DragEvent);
  }
  public headerTouchEnd() {
    this.headerDrop();
  }
  public headerDrop() {
    const target = this.columns[this.headerTargetId];
    if (target && this.headerDropTargetId >= 0) {
      let insertIndex = this.headerDropTargetId + (this.headerDropAfter ? 1 : 0);
      this.columns.splice(this.headerTargetId, 1);
      if (insertIndex > this.headerTargetId) insertIndex--;
      this.columns.splice(insertIndex, 0, target);
      this.columns.forEach((column, position) => column.position = position);
      this.saveColumns();
    }
    this.headerTargetId = -1;
    this.headerDropTargetId = -1;
    this.headerDropAfter = false;
  }
  //IEditor実装
  public validator: Components.Validator = new Components.Validator();
  public controls: Components.IControl[] = new Array();

  public addControl(control: Components.IControl) {
    if (control.validator != null) {
      this.validator.Validators.push(control.validator);
    }
    control.isEdit = true; //編集状態を強制する
    this.controls.push(control);
  }
  public removeControl(control: Components.IControl){
    if (control.validator != null) {
      var index = this.validator.Validators.indexOf(control.validator);
      if (index != -1) this.validator.Validators.splice(index, 1);
    }    
    var index1 = this.controls.indexOf(control);
    if (index1 != -1) this.controls.splice(index1, 1);    
  }
  public onCustomOK(e:any, index:number){
    this.exeIndex = index;
    this.onOk(e);
  }
  exeIndex:number = null;
  // OKボタン
  public onOk(e: any) {
    if(this.captions && this.captions.length > 0 && this.items.length == 0) return;
    //バリデーションを実行する～どうやって?
    e.preventDefault();
    if (this.validator.validate()) {
      //呼び出しもとにイベント処理してもらう
      if (this.primitive) {
        let temp = new Array();
        this.items.forEach(obj => temp.push(obj.value));
        //this.$emit('ok', temp);
        this.onExec(temp);
      } else {
        // this.$emit('ok', this.items);
        this.onExec(this.items);
      }
    // } else {
    //   e.preventDefault();
    }
  }

  public onExec(items:any[]){
    this.$api.startWaitCusor();
    if (this.exec != null){
      //レスポンスが帰ってきたら閉じる

      this.exec(items).then(
        success => {
          this.$api.closeWaitCursor();
          if (this.isRemainAfterExec) this.show = true;
          else this.show = (success || success == undefined) ? false : true;
        }
        );
    } else if (this.execWithIndex != null){
      this.execWithIndex(items,this.exeIndex).then(
        success => {
          this.$api.closeWaitCursor();
          this.show = (success || success == undefined) ? false : true;
        }
        );
    
    } else {
        this.$emit('ok', items);
        this.show = false;      
        this.$api.closeWaitCursor();
    }
    
  }
  
  public listDialog_rowKey:number = 0;
  public setRowKey(item:any){
    item.listDialog_rowKey = 'rowKey_' + this.listDialog_rowKey++;
  }
  //行追加ボタン
  public onAddRow() {
    //配列に新規追加する
    var instance :any = null;
    if (this.primitive) instance = { value: this.defaultValue };
    else instance = this.$api.createInstance(this.modelName);
    this.setRowKey(instance);

    if (this.onCreate) this.onCreate(instance).then((obj)=>this.items.push(obj));
    else this.items.push(instance);

  }

  // 行削除ボタン
  public onRemoveRow(index: number) {
    //これじゃダメな気がするけど
    this.items.splice(index, 1);
  }
  //行追加～外部からの追加
  public onAddItem(item:any){
    this.setRowKey(item);
    this.items.push(item);
  }

  //ダイアログ最大化サポート
  public maximized : boolean = false;
  public onChangeDisplayMode(){
    this.maximized = !this.maximized;
  }
}
</script>
<style lang="scss">
@import '@/agiles/components/style.scss';
.cx_listEditor3 {
  --cx-list-field-gap: 2px;
  --cx-list-control-inset: 2px;
  
  @include cx_dialog_spmode;


  .cx_list_dialog_outer{
    position: relative;
    padding: 5px 20px;

    .cx_spmode & {
      padding: 5px 0px;
    }
  }
  .dialog_resize_handle {
    position: absolute;
    right: 3px;
    bottom: 3px;
    width: 16px;
    height: 16px;
    cursor: nwse-resize;
    touch-action: none;
    z-index: 20;
    opacity: .55;
    background: linear-gradient(135deg, transparent 0 43%, #999 44% 48%, transparent 49% 58%, #999 59% 63%, transparent 64% 73%, #999 74% 78%, transparent 79%);
    &:hover {
      opacity: .9;
    }
  }
  .cx_list_wrap_header {
    max-width: 800px;
    display: flex;
    align-items: stretch;
    padding: 4px 5px;
    border: 1px solid lightgray;
    // border-bottom: none;
    background: linear-gradient(to bottom, #f7f7f7 0%, #e3e3e3 100%);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .9);
    .remove_header {
      flex: 0 0 30px;
    }
    .leading_header {
      flex: 0 0 30px;
    }
    .cx_list_wrap_caption {
      box-sizing: border-box;
      flex: 0 0 auto;
      max-width: 100%;
      min-width: 40px;
      height: 24px;
      display: flex;
      align-items: center;
      position: relative;
      padding: 3px 10px;
      font-size: 12px;
      font-weight: 600;
      color: #444;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      > span {
        position: relative;
        z-index: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1 1 auto;
        padding-right: 20px;
      }
      .cx_list_header_grip {
        position: absolute;
        top: 50%;
        right: 6px;
        z-index: 1;
        font-size: 16px;
        transform: translateY(-50%);
        cursor: grab;
        &:active {
          cursor: grabbing;
        }
      }
      &::before {
        content: '';
        position: absolute;
        top: 0;
        right: var(--cx-list-control-inset);
        bottom: 0;
        left: var(--cx-list-control-inset);
        border: 1px solid #9ab2c5;
        border-radius: 3px;
        background: #f0f5f8;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, .8), 0 1px 1px rgba(0, 0, 0, .04);
      }
      &.cx_list_header_drop_target::after {
        content: '';
        position: absolute;
        z-index: 2;
        top: 1px;
        bottom: 1px;
        left: -2px;
        width: 3px;
        border-radius: 2px;
        background: #1976d2;
      }
      &.cx_list_header_drop_target.cx_list_header_drop_after::after {
        right: auto;
        left: 100%;
      }
      &.cx_list_header_drop_target.cx_list_header_drop_last::after {
        right: 0;
        left: auto;
        width: 1px;
      }
    }
  }
  .cx_list_container{
    max-width: 800px;
    // max-height: 300px;
    // height: 400px;
    overflow-x:auto;
    // white-space: nowrap;
    border: 1px solid lightgray;
    border-top:none;
    margin-bottom: 10px;

    table{
      border-top:none;
    }
  }
  .cx_list_wrap_container {
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #fff;
    &.cx_list_no_wrap {
      overflow-x: auto;
    }
  }
  .cx_list_wrap_row {
    display: flex;
    align-items: stretch;
    min-width: 0;
    padding: 4px 5px;
    border-bottom: 1px solid #ddd;
    &.rowHighlight {
      background-color: #cae5e9;
    }
  }
  .cx_list_wrap_fields {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: var(--cx-list-field-gap);
    min-width: 0;
  }
  .cx_list_no_wrap {
    .cx_list_wrap_fields {
      flex: 0 0 auto;
      flex-wrap: nowrap;
      width: max-content;
    }
  }
  .cx_list_wrap_container.cx_list_no_wrap .cx_list_wrap_row {
    width: max-content;
    min-width: 100%;
  }
  .cx_list_wrap_header.cx_list_no_wrap {
    overflow-x: hidden;
  }
  .cx_list_wrap_cell {
    box-sizing: border-box;
    flex: 0 0 auto;
    max-width: 100%;
    min-width: 40px;
    padding: 0;
    .cx_control_input {
      width: 100%;
      min-width: unset;
    }
  }

  // 他画面へ移植する場合はここから
  // ListDialog2 配下ではコントロールを縦に詰め、検証メッセージは hover／focus 時だけポップアップ表示する
  .cx_list_wrap_cell {
    position: relative;
    .cx_control:not(.cx_list_wrap_cell .cx_layer .cx_control) {
      min-height: 22px;
      align-items: center;
      .cx_control_caption {
        display: none;
      }
      .cx_control_input {
        min-width: 0;
        overflow: visible;
        > div {
          position: relative;
          // Control.vue の :style="{ height: height + 'px' }" を ListDialog2 内だけ上書きする
          height: 22px !important;
        }
      }
      .cx_control_validation {
        display: none;
        position: absolute;
        z-index: 200;
        top: calc(100% + 2px);
        left: 0;
        min-width: 100%;
        max-width: 280px;
        padding: 2px 5px;
        border: 1px solid #fd6e6e;
        border-radius: 3px;
        background: #fff4f4;
        color: #c62828;
        box-shadow: 0 2px 6px rgba(0, 0, 0, .16);
        font-size: 10px;
        line-height: 1.15;
        white-space: normal;
        pointer-events: none;
      }
      &:focus-within {
        z-index: 10;
        .cx_control_validation:not(:empty) {
          display: block;
        }
      }
    }
  }
  // 他画面へ移植する場合はここまで
  .button {
    // font-size: 14px;
    // height: 28px;

    // padding-top: 2px;
    // margin-top: -3px;
    outline: 0 !important;
    margin-left:10px;
    height: 38px;
    box-shadow: none;
    i {
      font-size: 22px;
    }
  }
  .button_remove {
    width: 30px;
    color: #666666;
    &:hover {
      color: #242020;
    }
    i {
      font-size: 22px;
    }
  }
  .add_div {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .cx_margin_row{
    height: 12px;
  }
  .control_cell {
    // padding-top: 4px;
    padding-left: var(--cx-list-control-inset);
    padding-right: var(--cx-list-control-inset);

    .cx_control_input{
      min-width: unset;
      .cx_control_input_read{        
        padding-left : 10px;
      }

    }

    &.end{
      padding-right:15px;
    }
  }

  .cx_grid{
      .cx_card_item {
        padding-left: 10px;
        padding-right:5px;        
      }
  }
  .remove_cell {
    box-sizing: border-box;
    flex: 0 0 30px;
    display: flex;
    align-items: center;
    //padding-top: 10px;
    //padding-right: 10px;
    //padding-left: 5px;

  }
  .leading_cell {
    box-sizing: border-box;
    flex: 0 0 30px;
    display: flex;
    align-items: center;
  }
  table {
    table-layout: fixed;
    //在庫振替で線が二重化しているのでコメント
    // border-top: 1px solid #ccc;
    .rowHighlight {
      background-color: #cae5e9;
    }
  }
  th {
    position: relative;
    display: table-cell;
    border-bottom: 1px solid #ccc;

    border-top: 1px solid #fff;
    height: 30px;
    vertical-align: middle;

    text-align: left;
    overflow: hidden;
    padding: 0;
    background: -webkit-linear-gradient(top, #eee 0%, #e0e0e0);
    background: -moz-linear-gradient(top, #eee 0%, #e0e0e0);
    background: -ms-linear-gradient(top, #eee 0%, #e0e0e0);
    background: -o-linear-gradient(top, #eee 0%, #e0e0e0);
    background: linear-gradient(top, #eee 0%, #e0e0e0);
    background: #e7e7e7;
    background: -webkit-gradient(linear, left top, left bottom, from(#eee), to(#e0e0e0));
  }
  .selector {
    max-height: 400px;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    padding: 5px 10px 5px 15px;
    .selector_size {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 0 20px 10px 0;
      margin-bottom: 8px;
      border-bottom: 1px solid #ddd;
      flex-wrap: wrap;
    }
    .selector_wrap_option {
      label {
        display: block;
        margin-bottom: 2px;
        color: #555;
        font-size: 12px;        
      }
    }
    .selector_size_item {
      width: 120px;
      height: 56px;
      label {
        display: block;
        margin-bottom: 2px;
        color: #555;
        font-size: 12px;
        text-align: left;
      }
      .cx_control_input {
        min-width: unset;
        width: 100px;
      }
      .vue-js-switch{
        margin-top:8px;
        .v-switch-label.v-right{
          right:unset !important;
          left :30px;
        }        
      }
    }
    .selector_body {
      overflow-y: auto;
    }
    table.dialog {
      width: fit-content;
    }
    .dialog_cell {
      padding: 3px 15px 3px 0;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 0;
      .custom-control-label {
        padding-left: 30px;
      }
      .custom-control-label::after,
      .custom-control-label::before {
        left: 0;
        top: 0;
      }
    }
    .dialog_grip {
      padding-right: 20px;
      &:active { cursor: grabbing; }
      &:hover { cursor: grab; }
    }
    .dialog_width {
      width: 100px;
      padding-right: 15px;
      .custom-select {
        width: 80px;
      }
    }
  }
  .modal-dialog {
    position: relative;
    //tooltipが見切れるためoverflowを移動
    // overflow-y: auto;
    // overflow-x: auto;
    width: fit-content;
    min-width: 300px;
    max-width: none;
    .modal-header,
    .modal-footer {
      padding:0.6rem 2rem;
    }
    //tooltipが見切れるためoverflowを移動 ⇒ カレンダーが上手く表示されないためコメントアウト
    .modal-body {
      max-height: calc(100vh * 0.8 - 134px);
      overflow-y: auto;
      padding: 1rem 1rem 0.5rem 1rem;
    }
    .modal-footer {
      border-top: unset;
    }
  }
  //携帯端末の高さ不具合対応
  .modal-dialog-centered::before {
      height: calc(100dvh - 1rem);
  }     
  .modal-dialog.cx_list_main_dialog {
      height: auto;
      // modal-dialog-centered のflex中央配置を、初期表示・リサイズ後ともに維持する。
      min-height: calc(100dvh - 1rem);
      max-width: calc(100vw - 20px);
      // max-height: calc(100vh - 20px);
      margin: .5rem auto;
    > .modal-content {
        display: flex;
        flex-direction: column;
      width: var(--cx-list-dialog-width, fit-content);
      height: var(--cx-list-dialog-height, auto);
        min-height: 0;
        max-height: calc(100dvh - 20px);
        max-width: 100%;
        //予定在庫ポップアップが見切れるためコメント
        // overflow: hidden;
        > .modal-header,
        > .modal-footer {
          flex: 0 0 auto;
        }
        > .modal-body {
          display: flex;
          flex: 1 1 auto;
          min-height: 0;
          max-height: unset;
          overflow: hidden;
          > .cx_list_dialog_outer {
            display: flex;
            flex: 1 1 auto;
            flex-direction: column;
            min-height: 0;
            width: 100%;
            .cx_list_wrap_header {
              flex: 0 0 auto;
              max-width: unset;
            }
            .cx_list_container {
              max-width: unset;
              min-height: 0;
              flex-shrink: 1;
            }
          }
        }
    }
  }
  .maximize {
    padding: 17px 16px 16px 16px;
    margin: -15px -0 -1rem auto;
    box-shadow: none;
    outline: none;
    border: unset;
    background-color: white;    
    opacity: 0.5;
    height: 53px;
    &:hover {
      opacity: 0.75;
    }
  }
  &.cx_modal_maximized  {
    .modal-dialog.cx_list_main_dialog {
      margin: 0px;      
      width: 100vw !important;
      height:var(--vh) !important;
      min-height: 0;
      max-width: unset !important;
      max-height: unset;
      .modal-content{
        height:var(--vh) !important;  //アドレスバーの高さ分誤差が出るのでJavaScriptで計算      
        width: 100vw !important; //device-width        
      }
      .modal-body{
        overflow-y:auto;
        max-height: unset;
      }
      .modal-footer{
        padding-right :100px;        
      }
      .cx_editPanel_left,
      .cx_editPanel_right {
          padding-left: 10px;
          padding-right: 10px;        
          min-width: 345px;  //iphone          
      }    

      .cx_list_dialog_outer{
        display: flex;
        flex-direction: column;
        min-height: 100%;

        .cx_list_container{
          max-height: unset;
        }

        .cx_grid{
          width:100% !important; //在庫振替
        }
      }
    }
  }    
  .cx_modal_footer_button_container{
    flex: 1;
    display: flex;
  }
}
// BootstrapVue の b-modal は body 配下へ移動されるため、親コンポーネントの入れ子にしない
.cx_list_column_selector_modal {
  .modal-dialog {
    // width: fit-content !important;
    height: auto !important;
    min-height: 0 !important;
    max-width: none !important;
    max-height: none !important;
    margin: auto !important;
    .modal-content {
      display: block !important;
      height: auto !important;
      min-height: 0 !important;
      max-height: none !important;
      overflow: visible !important;
      max-width: 100%  !important;
      .modal-body {
        display: block !important;
        height: auto !important;
        max-height: calc(100vh * 0.8 - 134px) !important;
        overflow-y: auto !important;
      }
    }
  }
}
</style>
